import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import { MaxConversationGroup, MaxConversationSummary } from '../../types'
import ConversationItem from './conversation-item'

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(0.5, 1),
    display: 'flex',
    flexDirection: 'column',
  },
  group: {
    marginBottom: theme.spacing(3),
  },
  groupTitle: {
    padding: theme.spacing(0.5, 3),
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  groupItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  emptyState: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
}))

type ConversationsListProps = {
  groups: MaxConversationGroup[]
  activeId: string | null
  onSelectConversation: (conversationId: string) => void
  onRenameConversation: (conversation: MaxConversationSummary, nextTitle: string) => Promise<void> | void
  onTogglePinConversation: (conversation: MaxConversationSummary) => Promise<void> | void
  onDeleteConversation: (conversation: MaxConversationSummary) => Promise<void> | void
}

const ConversationsList = ({
  groups,
  activeId,
  onSelectConversation,
  onRenameConversation,
  onTogglePinConversation,
  onDeleteConversation,
}: ConversationsListProps) => {
  const classes = useStyles()

  if (groups.length === 0) {
    return (
      <div className={classes.root}>
        <Typography variant="body2" className={classes.emptyState}>
          No conversations found.
        </Typography>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {groups.map((group) => (
        <div key={group.label} className={classes.group}>
          <Typography variant="caption" className={classes.groupTitle}>
            {group.label}
          </Typography>
          <div className={classes.groupItems}>
            {group.conversations.map((conversation) => (
              <ConversationItem
                key={conversation.id}
                conversation={conversation}
                isActive={conversation.id === activeId}
                onSelectConversation={onSelectConversation}
                onRenameConversation={onRenameConversation}
                onTogglePinConversation={onTogglePinConversation}
                onDeleteConversation={onDeleteConversation}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ConversationsList
